import React from 'react';
import logo from '../assets/logo.png';
import './ReceiptModal.css';

const ReceiptModal = ({ isOpen, onClose, data }) => {
  if (!isOpen || !data) return null;

  const handlePrint = () => {
    window.print();
  };

  const formatDate = (dateString) => {
    if (!dateString) return new Date().toLocaleString('es-CO');
    const date = new Date(dateString);
    return date.toLocaleString('es-CO');
  };

  return (
    <div className="modal-overlay no-print" onClick={onClose}>
      <div className="receipt-modal" onClick={(e) => e.stopPropagation()}>
        <div className="receipt-header">
          <img src={logo} alt="TRANSIAPP" className="receipt-logo" />
          <h2>RECIBO DE PAGO AUTOMÁTICO</h2>
          <p className="receipt-subtitle">TRANSIAPP - COMPROBANTE INTERNO</p>
        </div>

        <div className="receipt-content">
          <div className="receipt-section">
            <span className="label">Referencia CUPL:</span>
            <span className="value highlight">{data.cupl_number}</span>
          </div>

          <div className="receipt-grid">
            <div className="receipt-item">
              <span className="label">Fecha de Pago:</span>
              <span className="value">{formatDate(data.paid_at || new Date())}</span>
            </div>
            <div className="receipt-item">
              <span className="label">Placa:</span>
              <span className="value">{data.plate || 'NA'}</span>
            </div>
          </div>

          <div className="receipt-section">
            <span className="label">Propietario:</span>
            <span className="value">{data.owner_name}</span>
          </div>

          <div className="receipt-section">
            <span className="label">Tipo de Trámite:</span>
            <span className="value">{data.tramite_name}</span>
          </div>

          <div className="receipt-divider"></div>

          <div className="receipt-grid">
            <div className="receipt-item">
              <span className="label">Estado RUNT:</span>
              <span className="value status-success">PAGO EXITOSO</span>
            </div>
            <div className="receipt-item">
              <span className="label">Transacción Ext:</span>
              <span className="value small-text">{data.external_id || 'AUTO_' + Date.now()}</span>
            </div>
          </div>

          <div className="receipt-total">
            <span className="total-label">VALOR PAGADO:</span>
            <span className="total-amount">
              ${(data.total_amount || data.tramite_value || 0).toLocaleString('es-CO')}
            </span>
          </div>
        </div>

        <div className="receipt-footer">
          <p>Este documento es un comprobante interno de la transacción realizada a través del sistema PAGO QPL.</p>
          <p className="thanks">¡Gracias por usar nuestro servicio!</p>
        </div>

        <div className="receipt-actions no-print">
          <button onClick={handlePrint} className="btn-primary">
            🖨️ Imprimir Recibo
          </button>
          <button onClick={onClose} className="btn-secondary">
            Cerrar
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReceiptModal;
